import { Button, DialogActions, Stack, Typography, styled } from "@mui/material"
import { ChevronLeft } from "react-feather"

interface WrongAccountProps {
  onClickGoHome: () => void
}

export const WrongAccount = ({ onClickGoHome }: WrongAccountProps) => {
  return (
    <WrongAccountActions>
      <NotYourAccountLabel color="primary.main">
        Ce n’est pas votre compte ?
      </NotYourAccountLabel>
      <WrongAccountButton variant="outlined" onClick={onClickGoHome}>
        <Stack direction="row" gap={1} alignItems="center">
          <ChevronLeft size={16} />
          <span>Retour à l’accueil</span>
        </Stack>
      </WrongAccountButton>
    </WrongAccountActions>
  )
}

const WrongAccountActions = styled(DialogActions)(({ theme }) => ({
  flexDirection: "column",
  gap: theme.spacing(1),
  background: theme.palette.background.default,
  padding: `${theme.spacing(3)} 0px`,
}))

const NotYourAccountLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: theme.typography.pxToRem(16),
}))

const WrongAccountButton = styled(Button)(({ theme }) => ({
  borderColor: theme.palette.primary.dark1,
  color: theme.palette.primary.dark1,
}))
